/* Pupilmobil – skrypty sklepu */
(function () {
  if (window.__pupilmobil) return;
  window.__pupilmobil = true;

  var fmtDM = new Intl.DateTimeFormat('pl-PL', { day: 'numeric', month: 'short' });
  var fmtD = new Intl.DateTimeFormat('pl-PL', { day: 'numeric' });

  function dodajDni(d, n) {
    var x = new Date(d.getTime());
    x.setDate(x.getDate() + n);
    return x;
  }

  function zakres(a, b) {
    if (a.getMonth() === b.getMonth()) return fmtD.format(a) + '–' + fmtDM.format(b);
    return fmtDM.format(a) + ' – ' + fmtDM.format(b);
  }

  // Na komputerze motyw Horizon przewija strone wewnatrz .page-wrapper, na telefonie cale okno.
  function przewijacze() {
    var lista = [window];
    var pw = document.querySelector('.page-wrapper');
    if (pw) lista.push(pw);
    return lista;
  }

  function pozycjaPrzewiniecia() {
    var pw = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
  }

  function initDaty(scope) {
    var s = scope || document;
    var dzis = new Date();
    s.querySelectorAll('[data-pupil-dzis]').forEach(function (el) {
      el.textContent = 'dziś, ' + fmtDM.format(dzis);
    });
    s.querySelectorAll('[data-pupil-zakres]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 5;
      var max = parseInt(el.getAttribute('data-max'), 10) || 10;
      el.textContent = zakres(dodajDni(dzis, min), dodajDni(dzis, max));
    });
  }

  function initGaleria(root) {
    var tasma = root.querySelector('[data-galeria-tasma]');
    if (!tasma) return;
    var slajdy = tasma.children;
    var miniatury = root.querySelectorAll('[data-galeria-miniatura]');
    var kropki = root.querySelectorAll('[data-galeria-kropka]');
    var aktywny = 0;

    function oznacz(i) {
      aktywny = i;
      miniatury.forEach(function (m, k) {
        var wlaczona = k === i;
        m.classList.toggle('is-active', wlaczona);
        m.setAttribute('aria-current', wlaczona ? 'true' : 'false');
        if (wlaczona) {
          var c = m.parentElement;
          c.scrollTo({ left: m.offsetLeft - (c.clientWidth - m.clientWidth) / 2, behavior: 'smooth' });
        }
      });
      kropki.forEach(function (m, k) {
        m.classList.toggle('is-active', k === i);
      });
    }

    function idz(i) {
      var n = slajdy.length;
      if (!n) return;
      i = (i + n) % n;
      tasma.scrollTo({ left: slajdy[i].offsetLeft, behavior: 'smooth' });
      oznacz(i);
    }

    root.querySelectorAll('[data-galeria-poprzedni]').forEach(function (b) {
      b.addEventListener('click', function () { idz(aktywny - 1); });
    });
    root.querySelectorAll('[data-galeria-nastepny]').forEach(function (b) {
      b.addEventListener('click', function () { idz(aktywny + 1); });
    });
    miniatury.forEach(function (m, k) { m.addEventListener('click', function () { idz(k); }); });
    kropki.forEach(function (m, k) { m.addEventListener('click', function () { idz(k); }); });

    var timer;
    tasma.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(tasma.scrollLeft / tasma.clientWidth);
        if (i !== aktywny) oznacz(i);
      }, 80);
    }, { passive: true });
  }

  function initZestawy(root) {
    var ceny = root.querySelectorAll('[data-pupil-cena-wybrana]');
    function odswiez() {
      var r = root.querySelector('input[name=quantity]:checked');
      if (!r) return;
      root.querySelectorAll('.pupil-zestaw').forEach(function (k) {
        k.classList.toggle('is-active', k.contains(r));
      });
      ceny.forEach(function (c) { c.textContent = r.getAttribute('data-cena'); });
    }
    root.querySelectorAll('input[name=quantity]').forEach(function (r) {
      r.addEventListener('change', odswiez);
    });
    odswiez();
  }

  function initMini(root) {
    var box = root.querySelector('[data-pupil-mini]');
    if (!box) return;
    var elementy = box.querySelectorAll('.pupil-mini__item');
    var i = 0;
    function pokaz(n) {
      i = (n + elementy.length) % elementy.length;
      elementy.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
    }
    var p = box.querySelector('[data-mini-poprzedni]');
    var nx = box.querySelector('[data-mini-nastepny]');
    if (p) p.addEventListener('click', function () { pokaz(i - 1); });
    if (nx) nx.addEventListener('click', function () { pokaz(i + 1); });
  }

  function initSticky(root) {
    var kup = root.querySelector('[data-pupil-kup]');
    var pasek = root.querySelector('[data-pupil-sticky]');
    if (!kup || !pasek || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (wpisy) {
      var e = wpisy[0];
      pasek.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(kup);
  }

  function initProdukt(root) {
    initGaleria(root);
    initZestawy(root);
    initMini(root);
    initSticky(root);
  }

  function initSzuflada() {
    var sz = document.querySelector('[data-pupil-szuflada]');
    var btn = document.querySelector('[data-pupil-szuflada-otworz]');
    if (!sz || !btn || sz.dataset.gotowy) return;
    sz.dataset.gotowy = '1';
    var zamknijBtn = sz.querySelector('.pupil-szuflada__zamknij');
    function otworz() {
      sz.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      if (zamknijBtn) zamknijBtn.focus();
    }
    function zamknij() {
      sz.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      btn.focus();
    }
    btn.addEventListener('click', otworz);
    sz.querySelectorAll('[data-pupil-szuflada-zamknij]').forEach(function (el) {
      el.addEventListener('click', zamknij);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sz.classList.contains('is-open')) zamknij();
    });
  }

  function initGora() {
    var g = document.querySelector('[data-pupil-gora]');
    if (!g || g.dataset.gotowy) return;
    g.dataset.gotowy = '1';
    var sprawdz = function () { g.classList.toggle('is-visible', pozycjaPrzewiniecia() > 400); };
    przewijacze().forEach(function (t) { t.addEventListener('scroll', sprawdz, { passive: true }); });
    sprawdz();
    g.addEventListener('click', function () {
      przewijacze().forEach(function (t) { t.scrollTo({ top: 0, behavior: 'smooth' }); });
    });
  }

  function start() {
    initDaty();
    document.querySelectorAll('[data-pupil-produkt]').forEach(initProdukt);
    initSzuflada();
    initGora();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (e) {
    initDaty(e.target);
    e.target.querySelectorAll('[data-pupil-produkt]').forEach(initProdukt);
    initSzuflada();
    initGora();
  });
})();
